import styled from 'styled-components';

interface RemoveButtonWrapperProps {
  type: 'active' | 'draft' | 'inactive';
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
  margin: 50px 0 0 0;
`;

export const TableHeader = styled.div`
  display: grid;
  margin-top: 16px;
  grid-template-columns: 1.2fr 0.8fr 1fr 0.8fr;
  max-width: 750px;
  margin-left: 24px;

  label {
    width: 100%;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #98a2b3;
  }
`;

export const TableRow = styled.div`
  display: grid;
  margin-top: 8px;
  grid-template-columns: 1.2fr 0.8fr 1fr 0.8fr;
  background: #ffffff;
  border: 1px solid #e4e9f0;
  box-sizing: border-box;
  box-shadow: 0px 4px 8px rgba(0, 34, 102, 0.1);
  border-radius: 6px;
  min-width: 800px;
  max-width: 800px;
  padding: 16px 24px;
  align-items: center;

  label {
    margin: 0;
    width: 100%;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #98a2b3;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;

  .table-row__options {
    flex: 1;
    margin-left: 20px;
    display: flex;
    align-items: center;
    max-width: 180px;

    span {
      cursor: pointer;
      font-weight: 500;
      font-size: 12px;
      line-height: 13px;
      color: #4a90e2;
    }
  }
`;

export const RemoveButtonWrapper = styled.div<RemoveButtonWrapperProps>`
  display: flex;
  align-items: center;
  margin-left: 30px;
  cursor: pointer;

  img {
    width: ${({ type }) => (type === 'active' ? 9 : 14)}px;
    margin-right: 8px;
  }

  span {
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: ${({ type }) =>
      type === 'active' ? '#bf3939' : '#4a90e2'} !important;
  }
`;
